import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(localizedFormat)

export interface FormatOptions {
  // defaults to 'lll'
  format?: string
  locale?: string
}
const defaultFormat = 'lll'

export function formatWallClockUTCNanos(
  wallClockEpochNanos: bigint,
  opts?: FormatOptions,
) {
  const millis = wallClockEpochNanos / 1_000_000n
  return formatWallClockUTCMillis(Number(millis), opts)
}

// Photos without timezone is stored in a way where the clock of the UTC timestamp will match the wall clock time of the photo timestamp.
// So a photo taken 2025-05-25 14:45 will be stored with a `timestamp_wallclock_nanos` that preserves the information that it was taken @14:45.
//
// Photos with timezone information, is moved to UTC with the same wall clock time.
// This means a photo with the information `2025-05-25 14:45 +0100` will be stored in a UTC timestamp that preserves the information about 14:45 (in UTC).
//
// When clients print the wall clock time, it must be printed in the UTC clock of the `timestamp_wallclock_nanos`.
// This is not the default in many environments, where clients will often print a timestamp in the timezone of the local device.
// In the above example we want all clients to print the wall clock 14:45, even if the client is in -0800 in New York, in +0100 in Oslo,
// or +10:00 in Australia.
export function formatWallClockUTCMillis(
  wallClockEpochMillis: number,
  opts?: FormatOptions,
) {
  // Use .utc() to interpret/display in UTC, not local time
  let ts = dayjs.utc(wallClockEpochMillis)
  const format = opts?.format || defaultFormat
  const localeOverride = opts?.locale
  if (localeOverride) {
    ts = ts.locale(localeOverride)
  }
  return ts.format(format)
}
